function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#1A8E96",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M2.732 2.913l9.526 5.5"
});

function SvgGreenStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGreenStroke;